'use client'

import React, {useEffect} from 'react'

import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {ReactQueryDevtools} from '@tanstack/react-query-devtools'

import {getQueryClient} from '@/src/shared/utils/query-client'
import {settings} from '../config/settings'

const showDevTools = settings.NEXT_PUBLIC_APP_ENV === 'development'

declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__: QueryClient
  }
}

export const QueryProviders = ({children}: React.PropsWithChildren) => {
  const client = getQueryClient()

  useEffect(() => {
    if (showDevTools) {
      window.__TANSTACK_QUERY_CLIENT__ = client
    }
  }, [])

  return (
    <QueryClientProvider client={client}>
      {children}

      {showDevTools && <ReactQueryDevtools />}
    </QueryClientProvider>
  )
}
